import React from 'react';

// A switch is a checkbox with role="switch": it keeps keyboard and screen-reader
// behaviour for free, and only the look is custom.
function Switch({ checked, disabled, onChange, label, testId }) {
  return (
    <label
      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: disabled ? 'wait' : 'pointer', flexShrink: 0 }}
    >
      <span style={{ fontSize: '12px', fontWeight: '600', color: checked ? '#059669' : '#6B7280' }}>{label}</span>
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
        data-testid={testId}
      />
      <span
        aria-hidden="true"
        style={{
          position: 'relative', width: '36px', height: '20px', borderRadius: '10px',
          background: checked ? '#059669' : '#D1D5DB', transition: 'background 0.15s',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <span
          style={{
            position: 'absolute', top: '2px', left: checked ? '18px' : '2px', width: '16px', height: '16px',
            borderRadius: '50%', background: 'white', transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
          }}
        />
      </span>
    </label>
  );
}

export default Switch;
